export enum SORT_BY {
  nearestFirst = "date_asc",
  furthestFirst = "date_desc",
  newestFirst = "createdOn_desc",
  oldestFirst = "createdOn_asc",
}
